import { render, staticRenderFns } from "./DistributionDataElementPath.vue?vue&type=template&id=6872f193&scoped=true"
import script from "./DistributionDataElementPath.vue?vue&type=script&lang=js"
export * from "./DistributionDataElementPath.vue?vue&type=script&lang=js"
import style0 from "./DistributionDataElementPath.vue?vue&type=style&index=0&id=6872f193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_prettier@2.8.8_vue-te_c4a30a065520cf149aadd974117fd210/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872f193",
  null
  
)

export default component.exports